import { ConfigProvider } from 'antd';
import { AppIntlContext } from 'core/intl/AppIntlProvider';
import { defaultLanguage, languages } from 'core/intl/languages';
import React, { useEffect, useState, FC } from 'react';

export const AntdConfigProvider: FC = ({ children }) => {
  const { currentLanguage } = React.useContext(AppIntlContext);
  const [locale, setLocale] = useState(defaultLanguage.antdLocale);

  useEffect(() => {
    setLocale(
      languages.find((l) => l.code === currentLanguage.code)?.antdLocale ||
        defaultLanguage.antdLocale
    );
  }, [currentLanguage]);

  return <ConfigProvider locale={locale}>{children}</ConfigProvider>;
};
